'use client';

import React, { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { pageLoadingStore, initializeHeroElementsDelay } from '@/stores/pageLoadingStore';

interface HeroTitleWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const HeroTitleWrapper = ({ children, className = '' }: HeroTitleWrapperProps) => {
  const snap = useSnapshot(pageLoadingStore);

  // Initialize the hero elements delay system
  useEffect(() => {
    initializeHeroElementsDelay();
  }, []);

  const heroTitleClass = snap.isHeroTitleReady ? 'hero-title-loaded' : 'hero-title-loading';

  return (
    <div className={`${heroTitleClass} ${className}`}>
      {children}
    </div>
  );
};

export default HeroTitleWrapper;
